import React, { useEffect } from "react";

interface ILoggedOutUser {
  onLogin: () => void;
}

const LoggedOutUser = ({ onLogin }: ILoggedOutUser) => (
  <button role="button"
    type='button'
    name="user"
    onClick={onLogin}
    className='btn slide-menu__control'
    data-action=''>
    Hey, Sign In / Sign Up
  </button>
);

export default LoggedOutUser;
